"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfBaseImporter = void 0;
var RtfBaseImporter = (function () {
    function RtfBaseImporter(data) {
        this.data = data;
    }
    Object.defineProperty(RtfBaseImporter.prototype, "documentModel", {
        get: function () { return this.data.documentModel; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RtfBaseImporter.prototype, "subDocument", {
        get: function () { return this.data.subDocument; },
        enumerable: false,
        configurable: true
    });
    RtfBaseImporter.prototype.applyState = function (states, state) {
        states.pop();
        states.push(state);
    };
    return RtfBaseImporter;
}());
exports.RtfBaseImporter = RtfBaseImporter;
